import styled from 'styled-components';
import Button from '../../Button/Button.es.js';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { palette, fontWeight, spacing } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';
var SelectedFilterItem = styled(Button).withConfig({
  componentId: "sc-19i1ko1-0"
})(["max-width:300px;-webkit-font-smoothing:antialiased;background-color:", ";font-weight:", ";margin-bottom:", ";svg{color:", ";}&:hover{background-color:", ";}"], palette("neutral.800"), fontWeight("regular"), spacing("md"), palette("neutral.400"), palette("neutral.600"));
export { SelectedFilterItem };